import { Responsive } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './MaterTabsLayout.css';

type TMasterTabsLayoutProps = {
  tabs: React.ReactNode;
  selectedSubAgent: React.ReactNode | null;
  masterTab: React.ReactNode | null;
  subAgentsTab: React.ReactNode | null;
  isMasterTabActive: boolean;
  isTopTabsRedesigned: boolean;
  changeListButtonNode: React.ReactNode | null;
};

export const MasterTabsLayout: React.FC<TMasterTabsLayoutProps> = React.memo(
  ({
    tabs,
    selectedSubAgent,
    masterTab,
    subAgentsTab,
    isMasterTabActive,
    isTopTabsRedesigned,
    changeListButtonNode,
  }) => {
    return (
      <Responsive desktop>
        <div className={styles['container']}>
          <div className={isTopTabsRedesigned ? styles['tabs-redesigned'] : styles['tabs']}>
            {tabs}
            {changeListButtonNode}
          </div>
          {isMasterTabActive ? (
            masterTab
          ) : (
            <>
              {selectedSubAgent}
              {subAgentsTab}
            </>
          )}
        </div>
      </Responsive>
    );
  },
);

MasterTabsLayout.displayName = 'MasterTabsLayout';
